<template>
  <div>
      <SaleMaster addNew="/sales/sales-invoice/" type="SI" ></SaleMaster>
  </div>
</template>

<script>
import SaleMaster from './master.vue'
export default {
  components: { SaleMaster }
}
</script>

<style>

</style>